import styled, { keyframes } from 'styled-components';
import { Flex } from '../../layout/Flex';

const animation = keyframes`
    0% {
        max-height: 56px;
        background: transparent;
    }

    50% {
        max-height: 56px;
        background: var(--control-primary-background);
    }

    100% {
        max-height: 100%;
        background: var(--control-primary-background);
    }
`;

export const Wrapper = styled(Flex).withConfig({ displayName: 'Wrapper' }).attrs({
    width: '100%',
    padding: 0.5,
    borderRadius: 3,
    overflow: 'hidden',
})``;

export const PromoWrapper = styled(Flex)
    .withConfig({ displayName: 'PromoWrapper' })
    .attrs({
        width: '100%',
        padding: 0.5,
        borderRadius: 3,
        overflow: 'hidden',
        background: { xs: 'none', lg: 'var(--control-primary-background)' },
        animationDuration: { xs: '0', lg: '2s' },
    })`
    animation-name: ${animation};
    animation-timing-function: ease-in-out;
`;
